module.exports = __webpack_public_path__ + "media/images/filter-fa79f99927040239663f8aa7fd8104ce.png";